window.userfunctions = {
    userIsNewVisitor : function (name) {
        return (window.s && window.s.eVar15 && window.s.eVar15 === 'New');
    }
}